import React, { Component }  from 'react'
import { Button, Icon } from 'semantic-ui-react'

import {
    ExcelExport,
    ExcelExportColumn
} from '@progress/kendo-react-excel-export'

class StudentsExport extends Component {
    _exporter;
    export = () => {
        this.save(this._exporter);
    }
    save = (component) => {
      const options = component.workbookOptions();

      component.save(options);
    };

    render() {
        return (
            <div>
                <Button icon labelPosition='right' onClick={this.export}>
                  <Icon name='download' />
                  Export Students
                </Button>

                <ExcelExport
                    data={this.props.data}
                    fileName={`Applicants-${this.props.gradeLevel}.xlsx`}
                    ref={(exporter) => { this._exporter = exporter; }}
                >
                  <ExcelExportColumn field="firstName" title="First Name" locked={true} width={200} />
                  <ExcelExportColumn field="lastName" title="Last Name" locked={true} width={200} />
                  <ExcelExportColumn field="middleName" title="Middle Name" width={200} />
                  <ExcelExportColumn field="studentNumber" title="Student Number" width={200} />
                </ExcelExport>
            </div>
        );
    }
}

export default StudentsExport;
